import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Grid, Row, Col, Alert } from "react-bootstrap";
import { clearMessage } from "../actions";

const _MessageBox = ({ message, clearMessage }) => {
  useEffect(() => {
    setTimeout(() => clearMessage(), 5000);
  }, []);

  return (
    <Grid>
      <Row>
        <Col md={6} xs={12} mdOffset={3}>
          <Alert bsStyle={message.type} closeLabel="Close">
            {message.text}
          </Alert>
        </Col>
      </Row>
    </Grid>
  );
};

const MessageBox = ({ message, clearMessage }) => {
  if (message === null) return null;

  return <_MessageBox message={message} clearMessage={clearMessage} />;
};

const mapStateToProps = (state) => ({
  message: state.message,
});

export default connect(mapStateToProps, { clearMessage })(MessageBox);
